const CalculatorIcon = ({ className, isSelected = false }) => {
  const fillColor = isSelected
    ? 'var(--forbrand-primary)'
    : 'var(--forbrand-secondary)'

  return (
    <div
      className={`${className} flex items-center justify-center w-[32px] h-[32px]`}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.5 8.00998V9.79999H4.29001V8.00998H2.5ZM3.79001 9.29999H3V8.50998H3.79001V9.29999ZM3.86499 3L3.57501 3.5H13V6H3V3H2.5V6.5H13.5V3H3.86499ZM15 13.25V1.5H1V14.5H14.71L15 14H1.5V2H14.5V13.25H15ZM5.57001 8.00998V9.79999H7.35999V8.00998H5.57001ZM6.85999 9.29999H6.07001V8.50998H6.85999V9.29999ZM8.64001 8.00998V9.79999H10.43V8.00998H8.64001ZM9.92999 9.29999H9.14001V8.50998H9.92999V9.29999ZM11.71 8.00998V9.79999H13.5V8.00998H11.71ZM13 9.29999H12.21V8.50998H13V9.29999ZM2.5 10.705V12.495H4.29001V10.705H2.5ZM3.79001 11.995H3V11.205H3.79001V11.995ZM5.57001 10.705V12.495H7.35999V10.705H5.57001ZM6.85999 11.995H6.07001V11.205H6.85999V11.995ZM8.64001 10.705V12.495H10.43V10.705H8.64001ZM9.92999 11.995H9.14001V11.205H9.92999V11.995ZM11.71 10.705V12.495H13.5V10.705H11.71ZM13 11.995H12.21V11.205H13V11.995Z"
          fill={fillColor}
          stroke={fillColor}
          strokeWidth="0.4"
        />
      </svg>
    </div>
  )
}

export default CalculatorIcon
